import React from "react";
import styles from './invoicesimplifiedheader.module.scss';
import { useTranslation } from "react-i18next";

type Props = {
  isProformaInvoices?: boolean;
}

const InvoiceSimplifiedHeader = ({ isProformaInvoices }: Props) => {
  // translations 
  const tLabels = useTranslation("invoice\\invoice").t;

  // helpers
  const getNumberTanslate = () => { 
    if (isProformaInvoices) {
      return tLabels("invoiceSimplifiedHeader.proformaInvoiceNumber");
    } else {
      return tLabels("invoiceSimplifiedHeader.number");
    }
  }

  // render
  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters px-2 px-lg-3">
        <div className="col">
          <div className="row no-gutters">
            <div className="col-8 col-lg-7 col-xl-8 col-xxl-9">
              <div className="row no-gutters">
                <div className="col-7 col-xl-5 col-xxl-4">
                  {tLabels("invoiceSimplifiedHeader.documentType")}
                </div>
                <div className="col-sm-5 col-lg-5 col-xl-7 col-xxl-8">
                  <div className="row no-gutters">
                    <div className="col-xl-6 col-xxl-4">
                      {getNumberTanslate()}
                      <span className="d-xl-none">/{tLabels("invoiceSimplifiedHeader.dueDate")}</span>
                    </div>
                    <div className="d-none d-xxl-block col-xxl-3">
                      {tLabels("invoiceSimplifiedHeader.variableSymbol")}
                    </div>
                    <div className="d-none d-xl-block col-xl-6 col-xxl-5 pl-xxl-4 pl-xxxl-5">
                      {tLabels("invoiceSimplifiedHeader.dueDate")}
                      <span className="d-none d-xxl-inline">{tLabels("invoiceSimplifiedHeader.timePeriod")}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-4 col-lg-5 col-xl-4 col-xxl-3 pl-3 pl-lg-0">
              <div className="row no-gutters">
                <div className="col-lg-7">
                  {tLabels("invoiceSimplifiedHeader.amount")}
                  <span className="d-lg-none">/{tLabels("invoiceSimplifiedHeader.state")}</span>
                </div>
                <div className="d-none d-lg-block col-lg-5">
                  {tLabels("invoiceSimplifiedHeader.state")}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`col-auto ${styles.btnCol}`}>
        </div>
      </div>
    </div>
  );
};

export default InvoiceSimplifiedHeader;
